<div [formGroup]="componentForm">
	<ng-container formGroupName="phoneInformation">
		<div class="row mb-3">
			<label class="col-md-3 col-form-label">Pref.</label>
			<div class="col-md-9">
				<pms-enum-select-button
						[attr.data-test-id]="'phoneEmailPrefButtons'"
						[enumList]="preferredPhoneTypeOptions"
						formControlName="preferredPhoneType">
				</pms-enum-select-button>
			</div>
		</div>
		<div [attr.data-test-id]="'phoneEmailHomePhoneInput'" class="row mb-3">
			<label class="col-12 col-md-3 col-form-label">Home</label>
			<div class="col-7 col-md-6 col-lg-5">
				<pms-phone-number-input formControlName="homePhone"></pms-phone-number-input>
			</div>
			<div class="col-5 col-md-3 col-lg-4">
				<div class="e-input-group">
					<span class="e-input-group-icon">x</span>
					<input class="e-input" type="text" formControlName="homePhoneExtension" />
				</div>
			</div>
		</div>
		<div [attr.data-test-id]="'phoneEmailWorkPhoneInput'" class="row mb-3">
			<label class="col-12 col-md-3 col-form-label">Work</label>
			<div class="col-7 col-md-6 col-lg-5">
				<pms-phone-number-input formControlName="workPhone"></pms-phone-number-input>
			</div>
			<div class="col-5 col-md-3 col-lg-4">
				<div class="e-input-group">
					<span class="e-input-group-icon">x</span>
					<input class="e-input" type="text" formControlName="workPhoneExtension" />
				</div>
			</div>
		</div>
		<div [attr.data-test-id]="'phoneEmailCellPhoneInput'" class="row mb-3">
			<label class="col-12 col-md-3 col-form-label">Cell</label>
			<div class="col-7 col-md-6 col-lg-5">
				<pms-phone-number-input formControlName="cellPhone"></pms-phone-number-input>
			</div>
			<div class="col-5 col-md-3 col-lg-4">
				<div class="e-input-group">
					<span class="e-input-group-icon">x</span>
					<input class="e-input" type="text" formControlName="cellPhoneExtension" />
				</div>
			</div>
		</div>
		<div [attr.data-test-id]="'phoneEmailPagerInput'" class="row mb-3">
			<label class="col-md-3 col-form-label">Pager</label>
			<div class="col-md-9">
				<pms-phone-number-input formControlName="pager"></pms-phone-number-input>
			</div>
		</div>
	</ng-container>
	<div [attr.data-test-id]="'phoneEmailEmailInput'" class="row mb-3">
		<label class="col-md-3 col-form-label">Email</label>
		<div class="col-md-9">
			<input class="e-input margin-bottom-sm" type="text" formControlName="email" />
		</div>
	</div>
</div>
